import { z } from 'zod';
import { PostsProjectType } from '../constants';

export const postSchema = z.object({
  id: z.string(),
  title: z.string(),
  content: z.string().nullable(),
  documentation: z.string().nullable(),
  date: z.date().nullable(),
  type: z.nativeEnum(PostsProjectType),
  archived: z.boolean(),
  externalId: z.string().nullable().optional(),
  externalData: z.record(z.string(), z.unknown()).nullable().optional(),
  isFinished: z.boolean(),
  scheduledAt: z.date().nullable().optional(),
  publishedAt: z.date().nullable().optional(),
  approvedAt: z.date().nullable().optional(),
  approverId: z.string().nullable().optional(),
  isClientVisible: z.boolean(),
  isImportedFromPlatform: z.boolean(),
  clientId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type PostSchema = z.infer<typeof postSchema>;
